import styles from "./style.module.scss";
import Text from "@components/shared/text";
import { translate } from "@helpers/translationObjectFormatter";
import {
    ICategoryPageSharedProps,
    TranslationsObject,
} from "@genericTypes/sharedTypes";
import { useQuery } from "@tanstack/react-query";
import { titleDecoder } from "@lib/sharedUtils";
import { Session } from "pages/api/session";

export default function CategoryIntro() {
    const { data: session } = useQuery<Session>(["session"]);
    const { data: translations } = useQuery<TranslationsObject>([
        "translations",
    ]);
    const { data } = useQuery<ICategoryPageSharedProps>([
        "categoryPageSharedProps",
    ]);
    const { textBlock, categoryName, categoryLabel } = data ?? {};

    return textBlock && Object.keys(textBlock ?? {}).length > 0 ? (
        <div className={` ${styles["mainContainer"]}`}>
            <div
                className="top-buyer-brief-text-block-container"
                dangerouslySetInnerHTML={{
                    __html: titleDecoder((textBlock?.text as string) ?? "", {
                        category: categoryName,
                        region: session?.visitDetails?.region,
                    }),
                }}
            />
        </div>
    ) : (
        <div className={` ${styles["mainContainer"]}`}>
            <Text
                type="title"
                className="lg:text-4xl text-xl lg:leading-[63px] leading-9"
            >
                {categoryLabel ?? categoryName ?? ""}
            </Text>
            <Text
                className={` ${styles["mainParagraph"]} lg:text-xl text-sm lg:leading-9 leading-6 lg:mt-3`}
            >
                {translate(translations, "several_category_topBuyerBrief", {
                    category: categoryLabel ?? categoryName ?? "",
                })}
            </Text>
        </div>
    );
}
